import React, {useEffect,useState, useContext, useRef} from 'react';
import { GlobalContext } from '../contexts/GlobalContext';
import {FormValidator,useFormValidator,Inputs,Message} from 'coaz-ui';
import client from '../client';

const AddCriteriaPathItem = ({params, submitRef, setLoading, setEnableSubmit}) => {
    const [parent,setParent] = useState({});
    const [criteriaPathItem,setCriteriaPathItem] = useState({});
    const [criteriaPathItems,setCriteriaPathItems] = useState([]);
    const minWidth = 240;
    const [inputWidth,setInputWidth] = useState(minWidth);
    const {request,errorMessage} = client

    const submit = async (e) => {
        try {
            criteriaPathItem.parent = parent;
            
            const response = await request('POST','criteria-path-items',criteriaPathItem);

            if (response && response.id) {
                return {
                    message: 'Successful',
                    success: true
                };
            }

            return {
                message: errorMessage(response)
            };
        } catch (error) {
            return {
                message: errorMessage(error)
            };
        }
    };

    const [register,handleChange,handleSubmit,errors] = useFormValidator(submit);

    const inputs = [
        {
            label:'Parent',
            type:'text', 
            name:'parent',
            value:parent && parent.name?parent.name:'',
            disabled:true
        },
        {
            label:'Child',
            type:'select',
            options:() => {
                let options = [];
                criteriaPathItems.map((option,i) => options.push(<option key={i} value={option.name}>{option.name}</option>));
                return options;
            },
            name:'child', 
            value:criteriaPathItem && criteriaPathItem.name?criteriaPathItem.name:'',
            placeholder:'Select child...',
            onChange:(e) => handleChange(e,onChange)
        }
    ]

    const onChange = (e) => {
        const value = criteriaPathItems.find((item) => {return item.name === e.target.value});
        if(value) {
          setCriteriaPathItem(value);
        } 
    }

    useEffect(() => {
        if (handleSubmit) {
            submitRef.current = { submit: handleSubmit };
            setEnableSubmit(true);
        } else {
            submitRef.current = null;
            setEnableSubmit(false);
        }

        return () => {
            submitRef.current = null;
        };
    }, [handleSubmit]);

    useEffect(() => {
        (async () => {
            if(params && params.parentId) {
                let par = null;
                await request('GET',`criteria-path-items/${params.parentId}`)
                .then((response) => {
                    if(response) {
                        par = response;
                        setParent(par);
                    }  else {
                        setParent(null);
                    }
                })
                .catch((error) => {
                    setParent(null);
                })
                
                if(par) {
                    await request('POST','criteria-path-items/create',null,{className:par.className})
                    .then((response) => {
                        if(response && response.length > 0) {
                            setCriteriaPathItems(response);
                            setCriteriaPathItem(response[0]);
                        }  else {
                            setCriteriaPathItems([]);
                        }
                    })
                    .catch((error) => {
                        setCriteriaPathItems([]);
                    })
                }
                setLoading(false)
            }
        })()
    },[]);

    return (
        <FormValidator>
            <div className='w-full h-auto shrink-0'>
                <Inputs inputs={inputs} minWidth={minWidth} paddingX={0} spaceX={32} id='add_course' setCalcWidth={setInputWidth}/>
            </div>
        </FormValidator>
      )
}

export default AddCriteriaPathItem